export default __webpack_public_path__ + "static/media/payment-order.940d5fc4.svg";